<template>
    <div class='tep-pv-calc-wrap'>
        <dx-button @click="calcPv">
            <img :src='"/infoenergo/assets/tep/tep-cards/formula.svg"' alt='' style='width: auto; height: 1.5em'>
            <span class='tep-btn-text'>РАСЧЁТ</span>
        </dx-button>
    </div>
</template>

<script>
export default {
    name: 'tep-pv-calc-button',
};
</script>

<script setup>
import { DxButton } from 'devextreme-vue';
import { inject } from 'vue';
import tepService from '@/service/tep-service';
import { dxUiNotify } from '@/utils/dx-helper';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

const userData = inject('userData');

const calcPv = async () => {
    const args = {
        p_p: userData.value.kod_vid === 25 ? Number(userData.value.p_p) :  Number(userData.value.p_pa),
        p_t: userData.value.kod_vid === 25 ? Number(userData.value.p_t) : Number(userData.value.p_ta),
        kod_harp: userData.value.kod_harp,
    }
    const result = await tepService.getHarpRaschet(args);
    if(result.status !== 0) {
        dxUiNotify(result.errmsg, 'error', 3000);
        return
    }
    if(userData.value.kod_vid === 25) {
        userData.value['ts'] = Number(result.po_ts).toFixed(2)
        if(userData.value.kod_harp === 10 && result.po_t) {
            const newVal = Number(result.po_t);
            userData.value.p_t = newVal;
            userData.value.t_ot = newVal - newVal / 100 * 5;
            userData.value.t_do = newVal + newVal / 100 * 5;
        }
    } else if (userData.value.kod_vid === 55) {
        userData.value['tsa'] = Number(result.po_ts).toFixed(2)
        if(userData.value.kod_harp === 10 && result.po_t) {
            const newVal = Number(result.po_t);
            userData.value.p_ta = result.po_t;
            userData.value.ta_ot = Math.round(newVal - newVal / 100 * 5,0);
            userData.value.ta_do = Math.round(newVal + newVal / 100 * 5,0);
        }
    }
    if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
}
</script>

<style scoped>
.tep-pv-calc-wrap {
    display: flex;
    align-items: center;
    width: max-content;
    padding-top: 10px;
}
.tep-pv-calc-wrap :deep(.dx-button) {
    height: 33px;
}
.tep-btn-text {
    margin-left: 0.5em;
    font-weight: 500;
}
</style>
